import React from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <section id="Contact" className="py-20 bg-gradient-to-b from-purple-50 to-white px-4">
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-purple-700 mb-10"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {t("contactus.title")}
        </motion.h2>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {/* Contact Info */}
          <div className="text-left space-y-8">
            <div className="flex items-start space-x-4">
              <FaMapMarkerAlt className="text-purple-700 text-3xl" />
              <div>
                <h4 className="font-semibold text-xl">{t("contactus.addressTitle")}</h4>
                <p className="text-gray-600">{t("contactus.address")}</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <FaPhoneAlt className="text-purple-700 text-3xl" />
              <div>
                <h4 className="font-semibold text-xl">{t("contactus.phoneTitle")}</h4>
                <p className="text-gray-600">{t("contactus.phone")}</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <FaEnvelope className="text-purple-700 text-3xl" />
              <div>
                <h4 className="font-semibold text-xl">{t("contactus.emailTitle")}</h4>
                <p className="text-gray-600">{t("contactus.email")}</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form className="space-y-5">
            <input
              type="text"
              name="name"
              placeholder={t("contactus.form.name")}
              className="w-full p-3 border border-purple-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <input
              type="email"
              name="email"
              placeholder={t("contactus.form.email")}
              className="w-full p-3 border border-purple-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <textarea
              name="message"
              rows="4"
              placeholder={t("contactus.form.message")}
              className="w-full p-3 border border-purple-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            ></textarea>
            <button
              type="submit"
              className="w-full py-3 bg-purple-600 text-white font-semibold rounded-md hover:bg-purple-700 transition"
            >
              {t("contactus.form.submit")}
            </button>
          </form>
        </motion.div>

        {/* Google Map */}
        <div className="mt-12 rounded-md overflow-hidden shadow-lg">
          <iframe
            src="https://maps.google.com/maps?q=natraj%20hospital%20bijolia&t=&z=13&ie=UTF8&iwloc=&output=embed" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen="yes"
            loading="lazy"
            title="Natraj Hospital Location Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
